module.exports = __webpack_public_path__ + "img/1327651489.4047ecce.jpg";